import React from "react";
import cn from "classnames";

import { Text, SearchFilter, SearchFilterCheckbox } from "@themuse/design-system";

import { FacetProps, getFacetProps } from "utils/searchFacets";
import {
    jobCategoryItems,
    experienceLevelItems,
    postedDateRangeItems,
    searchRadiusItems
} from "utils/searchFacetItems";

import styles from "../SearchFacets.module.scss";

// Jobfacets has a few extra props to
// support the remote checkbox filter
interface JobFacetsProps extends FacetProps {
    remoteIsSelected: boolean;
    updateRemoteIsSelected: (remoteIsSelected: boolean) => void;
    locationIsSelected: boolean;
}

const JobFacets = (props: JobFacetsProps) => {
    const {
        remoteIsSelected, updateRemoteIsSelected, locationIsSelected, ...rest
    } = props;

    const remoteCheckboxFacetProps = {
        label: "Remote/Flexible Only",
        checked: remoteIsSelected,
        onChange: () => {
            updateRemoteIsSelected(remoteIsSelected);
        }
    };

    return (
        <div className={styles.jobFilterSection}>
            <header className={styles.header}>
                <Text
                    htmlTag="h2"
                    textStyle="heading-3"
                    className={cn(styles.headerText, styles.subHeaderText)}
                >
                    Job Filters
                </Text>
            </header>
            <div className={styles.facetList}>
                <SearchFilter
                    {...getFacetProps({
                        fieldType: "radio",
                        userInputFilterName: "postedDateRange",
                        searchFilterItems: postedDateRangeItems,
                        labelText: "Date Posted",
                        defaultValue: "",
                        ...rest,
                    })}
                />
                <SearchFilter {...getFacetProps({
                    fieldType: "checkbox",
                    userInputFilterName: "category",
                    searchFilterItems: jobCategoryItems,
                    labelText: "Job Category",
                    ...rest,
                })}
                />
                <SearchFilter {...getFacetProps({
                    fieldType: "checkbox",
                    userInputFilterName: "experienceLevel",
                    searchFilterItems: experienceLevelItems,
                    labelText: "Experience Level",
                    ...rest,
                })}
                />
                <SearchFilterCheckbox {...remoteCheckboxFacetProps} />
                <SearchFilter
                    {
                        ...getFacetProps({
                            fieldType: "radio",
                            userInputFilterName: "radius",
                            searchFilterItems: searchRadiusItems,
                            labelText: "Search Radius",
                            defaultValue: "",
                            ...rest
                        })
                    }
                    disabled={!locationIsSelected}
                />
            </div>
        </div>
    );
};

export default JobFacets;
